import { render, staticRenderFns } from "./NewItemSendByImage.vue?vue&type=template&id=73534372&"
import script from "./NewItemSendByImage.vue?vue&type=script&lang=js&"
export * from "./NewItemSendByImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports